import { ServiceType, WorkflowTrigger } from '../../../../types'
import findServiceAndTriggerDescriptorByKey from './findServiceAndTriggerDescriptorByKey'

export default function getTriggerIcon(
  services: ServiceType[],
  trigger?: WorkflowTrigger
): string {
  if (!trigger) {
    return 'workflow'
  }

  const { service, triggerDescriptor } = findServiceAndTriggerDescriptorByKey(
    services,
    trigger
  )

  if (triggerDescriptor.icon) {
    return triggerDescriptor.icon
  }

  if (service.icon) {
    return service.icon
  }

  return 'workflow'
}
